export default {"src":"/_next/static/media/plant.7a0e0550.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};